// extracted by mini-css-extract-plugin
export default {"mainCountDown":"Timer_mainCountDown__TatwG"};